import {
  BottomSheetBody,
  BottomSheetHeader,
  BottomSheetHeaderTitle,
  Flex,
  FlexColumn,
  Separator,
} from "@opensea/ui-kit"
import { useTranslations } from "use-intl"
import { ActionTimelineSkeleton } from "../../../components/ActionTimeline/ActionTimelineSkeleton"
import { ReceiptDisplaySkeleton } from "../../../components/Receipt"

export function MintFlowSkeleton() {
  const t = useTranslations("wallet.MintFlowSkeleton")
  return (
    <>
      <BottomSheetHeader>
        <BottomSheetHeaderTitle>{t("mint")}</BottomSheetHeaderTitle>
      </BottomSheetHeader>
      <BottomSheetBody>
        <Flex className="size-full flex-col gap-6 md:flex-row md:gap-10">
          <ReceiptDisplaySkeleton />
          <Separator
            className="hidden h-auto md:block"
            orientation="vertical"
          />

          <FlexColumn className="w-full min-w-0 justify-end">
            <ActionTimelineSkeleton />
          </FlexColumn>
        </Flex>
      </BottomSheetBody>
    </>
  )
}
